 

document.addEventListener('DOMContentLoaded', function() {
  // --- Featured Collection Custom Scrollbar ---
  // Updated selector to match <slider-component> > <ul class="slider ...">
  const featuredSliders = document.querySelectorAll('slider-component > ul.slider');
   
  featuredSliders.forEach((slider, i) => {
     
    // Look for the new scrollbar sibling
    const scrollbar = slider.parentElement.querySelector('.featured-collection__scrollbar');
    if (!scrollbar) {
      return;
    }
    const thumb = scrollbar.querySelector('.featured-collection__scrollbar-thumb');
    if (!thumb) {
      return;
    }
     

    function updateThumbPosition() {
      const scrollPercentage = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
      const scrollbarInnerWidth = scrollbar.clientWidth - 140; // 70px padding on each side
      const maxTranslate = scrollbarInnerWidth - thumb.offsetWidth;
      const translateX = (scrollPercentage * maxTranslate) + 70;
      thumb.style.transform = `translateX(${translateX}px)`;
    }

    slider.addEventListener('scroll', function(e) {
       
      updateThumbPosition();
    });
    window.addEventListener('resize', function(e) {
       
      updateThumbPosition();
    });

    let isDragging = false;
    let startX, startLeft;

    thumb.addEventListener('mousedown', function(e) {
       
      startDrag(e);
    });
    thumb.addEventListener('touchstart', (e) => {
       
      startDrag(e.touches[0]);
    }, { passive: true });

    function startDrag(e) {
      isDragging = true;
      startX = e.clientX;
      const thumbRect = thumb.getBoundingClientRect();
      const scrollbarRect = scrollbar.getBoundingClientRect();
      startLeft = thumbRect.left - scrollbarRect.left;
      thumb.style.transition = 'none';
      document.body.style.userSelect = 'none';
       
    }

    function onDrag(e) {
      if (!isDragging) return;
      const clientX = e.clientX;
      const deltaX = clientX - startX;
      const scrollbarInnerWidth = scrollbar.clientWidth - 140;
      const maxTranslate = scrollbarInnerWidth - thumb.offsetWidth;
      let newLeft = startLeft + deltaX - 70;
      newLeft = Math.max(0, Math.min(newLeft, maxTranslate));
      const scrollPercentage = newLeft / maxTranslate;
      slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
       
    }

    function endDrag() {
      isDragging = false;
      thumb.style.transition = '';
      document.body.style.userSelect = '';
       
    }

    document.addEventListener('mousemove', onDrag);
    document.addEventListener('touchmove', (e) => {
      onDrag(e.touches[0]);
    }, { passive: false });
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);

    scrollbar.addEventListener('click', (e) => {
      if (e.target === thumb) return;
      const scrollbarRect = scrollbar.getBoundingClientRect();
      const clickPosition = e.clientX - scrollbarRect.left;
      const scrollbarInnerWidth = scrollbar.clientWidth - 140;
      const maxTranslate = scrollbarInnerWidth - thumb.offsetWidth;
      let newLeft = clickPosition - 70 - thumb.offsetWidth / 2;
      newLeft = Math.max(0, Math.min(newLeft, maxTranslate));
      const scrollPercentage = newLeft / maxTranslate;
      slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
       
    });

    // Initial position
    updateThumbPosition();
     
  });


   

  // Original testimonial slider code (unchanged)
  const testimonialSliders = document.querySelectorAll('.llm-testimonials__slider');
   
  
  testimonialSliders.forEach(slider => {
    const scrollbar = slider.nextElementSibling;
    if (!scrollbar || !scrollbar.classList.contains('llm-testimonials__scrollbar')) return;
    
    const thumb = scrollbar.querySelector('.llm-testimonials__scrollbar-thumb');
    if (!thumb) return;
    
    // Update thumb position on scroll
    function updateThumbPosition() {
      const scrollPercentage = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
      
      // Calculate available space for the thumb to move (accounting for padding)
      const scrollbarInnerWidth = scrollbar.clientWidth - 140; // 70px padding on each side
      const maxTranslate = scrollbarInnerWidth - thumb.offsetWidth;
      
      // Add 70px to account for the left padding
      const translateX = (scrollPercentage * maxTranslate) + 70;
      thumb.style.transform = `translateX(${translateX}px)`;
    }
    
    // Add event listeners
    slider.addEventListener('scroll', updateThumbPosition);
    window.addEventListener('resize', updateThumbPosition);
    
    // Make scrollbar draggable
    let isDragging = false;
    let startX, startLeft;
    
    // Handle thumb drag
    thumb.addEventListener('mousedown', startDrag);
    thumb.addEventListener('touchstart', (e) => {
      startDrag(e.touches[0]);
    }, { passive: true });
    
    function startDrag(e) {
      isDragging = true;
      startX = e.clientX;
      const thumbRect = thumb.getBoundingClientRect();
      const scrollbarRect = scrollbar.getBoundingClientRect();
      startLeft = thumbRect.left - scrollbarRect.left;
      thumb.style.transition = 'none';
      document.body.style.userSelect = 'none'; // Prevent text selection while dragging
    }
    
    // Handle scrollbar click (jump to position)
    scrollbar.addEventListener('click', (e) => {
      if (e.target === thumb) return; // Ignore clicks on the thumb itself
      
      const scrollbarRect = scrollbar.getBoundingClientRect();
      const clickPosition = e.clientX - scrollbarRect.left;
      
      // Account for the padding (70px on each side)
      if (clickPosition < 70 || clickPosition > scrollbarRect.width - 70) {
        return; // Click was in the padding area, ignore it
      }
      
      // Adjust click position to account for padding
      const adjustedClickPosition = clickPosition - 70;
      const scrollbarInnerWidth = scrollbarRect.width - 140;
      const scrollPercentage = adjustedClickPosition / scrollbarInnerWidth;
      
      // Scroll to the position
      slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
    });
    
    // Handle drag movement
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('touchmove', (e) => {
      onDrag(e.touches[0]);
    }, { passive: false });
    
    function onDrag(e) {
      if (!isDragging) return;
      
      const deltaX = e.clientX - startX;
      const newLeft = startLeft + deltaX;
      
      // Account for the 70px padding on left side
      const minLeft = 70;
      // Account for the 70px padding on right side
      const maxLeft = scrollbar.clientWidth - thumb.offsetWidth - 70;
      
      const boundedLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
      // Adjust the percentage calculation to account for padding
      const adjustedLeft = boundedLeft - minLeft;
      const adjustedMaxLeft = maxLeft - minLeft;
      const scrollPercentage = adjustedLeft / adjustedMaxLeft;
      
      slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
      e.preventDefault(); // Prevent page scrolling while dragging
    }
    
    // Handle drag end
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
    
    function endDrag() {
      if (isDragging) {
        isDragging = false;
        thumb.style.transition = 'transform 0.1s ease';
        document.body.style.userSelect = ''; // Restore text selection
      }
    }
    
    // Add keyboard navigation
    slider.setAttribute('tabindex', '0'); // Make slider focusable
    slider.addEventListener('keydown', (e) => {
      const step = 100; // Scroll amount in pixels
      
      if (e.key === 'ArrowRight') {
        slider.scrollLeft += step;
        e.preventDefault();
      } else if (e.key === 'ArrowLeft') {
        slider.scrollLeft -= step;
        e.preventDefault();
      }
    });
    
    // Initialize
    updateThumbPosition();
  });
  
  // New code for mobile collections slider only
  // Only run this code on mobile devices
   
  if (window.innerWidth < 750) {
     
    const collectionSliders = document.querySelectorAll('.llm-collections-mobile__slider');
     
    
    collectionSliders.forEach(slider => {
       
      const scrollbar = slider.closest('.llm-collections-mobile').querySelector('.llm-collections-mobile__scrollbar'); // CORRECTED SELECTOR
      if (!scrollbar) {
         
        return;
      }
       
      
      const thumb = scrollbar.querySelector('.llm-collections-mobile__scrollbar-thumb');
      if (!thumb) {
         
        return;
      }
       

      // Find the mobile category heading relative to the slider's parent container
      const mobileCategoryHeadingContainer = slider.closest('.llm-collections-mobile');
      const mobileCategoryHeading = mobileCategoryHeadingContainer ? mobileCategoryHeadingContainer.querySelector('.llm-category-heading-mobile') : null;
       
      
      // Variables specific to this slider instance
      let collectionIsDragging = false;
      let collectionStartX, collectionStartLeft;
      
      // Update thumb position on scroll
      function updateCollectionThumbPosition() {
         
         

        const scrollPercentage = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
        
        // Calculate available space for the thumb to move (accounting for padding)
        const scrollbarInnerWidth = scrollbar.clientWidth - 140; // 70px padding on each side
        const maxTranslate = scrollbarInnerWidth - thumb.offsetWidth;
        
        // Add 70px to account for the left padding
        const translateX = (scrollPercentage * maxTranslate) + 70;
        thumb.style.transform = `translateX(${translateX}px)`;

        // Toggle visibility of the mobile category heading
        if (mobileCategoryHeading) {
          if (slider.scrollLeft > 1) { // 1px threshold
            mobileCategoryHeading.classList.add('llm-category-heading-mobile--hidden');
             
          } else {
            mobileCategoryHeading.classList.remove('llm-category-heading-mobile--hidden');
             
          }
        } else {
           
        }
      }
      
      // Add event listeners
      slider.addEventListener('scroll', updateCollectionThumbPosition);
      window.addEventListener('resize', updateCollectionThumbPosition);
      
      // Handle thumb drag
      thumb.addEventListener('mousedown', startCollectionDrag);
      thumb.addEventListener('touchstart', (e) => {
        startCollectionDrag(e.touches[0]);
      }, { passive: true });
      
      function startCollectionDrag(e) {
        collectionIsDragging = true;
        collectionStartX = e.clientX;
        const thumbRect = thumb.getBoundingClientRect();
        const scrollbarRect = scrollbar.getBoundingClientRect();
        collectionStartLeft = thumbRect.left - scrollbarRect.left;
        thumb.style.transition = 'none';
      }
      
      // Handle scrollbar click (jump to position)
      scrollbar.addEventListener('click', (e) => {
        if (e.target === thumb) return; // Ignore clicks on the thumb itself
        
        const scrollbarRect = scrollbar.getBoundingClientRect();
        const clickPosition = e.clientX - scrollbarRect.left;
        
        // Account for the padding (70px on each side)
        if (clickPosition < 70 || clickPosition > scrollbarRect.width - 70) {
          return; // Click was in the padding area, ignore it
        }
        
        // Adjust click position to account for padding
        const adjustedClickPosition = clickPosition - 70;
        const scrollbarInnerWidth = scrollbarRect.width - 140;
        const scrollPercentage = adjustedClickPosition / scrollbarInnerWidth;
        
        // Scroll to the position
        slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
      });
      
      // Custom handlers for collection slider to avoid conflicts
      function collectionDragMove(e) {
        if (!collectionIsDragging) return;
        
        const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        const deltaX = clientX - collectionStartX;
        const newLeft = collectionStartLeft + deltaX;
        
        // Account for the 70px padding on left side
        const minLeft = 70;
        // Account for the 70px padding on right side
        const maxLeft = scrollbar.clientWidth - thumb.offsetWidth - 70;
        
        const boundedLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
        // Adjust the percentage calculation to account for padding
        const adjustedLeft = boundedLeft - minLeft;
        const adjustedMaxLeft = maxLeft - minLeft;
        const scrollPercentage = adjustedLeft / adjustedMaxLeft;
        
        slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
        e.preventDefault(); // Prevent page scrolling while dragging
      }
      
      function collectionDragEnd() {
        if (collectionIsDragging) {
          collectionIsDragging = false;
          thumb.style.transition = 'transform 0.1s ease';
        }
      }
      
      // Add collection-specific event listeners
      document.addEventListener('mousemove', function(e) {
        if (collectionIsDragging) {
          collectionDragMove(e);
        }
      });
      
      document.addEventListener('touchmove', function(e) {
        if (collectionIsDragging) {
          collectionDragMove(e);
        }
      }, { passive: false });
      
      document.addEventListener('mouseup', collectionDragEnd);
      document.addEventListener('touchend', collectionDragEnd);
      
      // Add keyboard navigation
      slider.setAttribute('tabindex', '0'); // Make slider focusable
      slider.addEventListener('keydown', (e) => {
        const step = 100; // Scroll amount in pixels
        
        if (e.key === 'ArrowRight') {
          slider.scrollLeft += step;
          e.preventDefault();
        } else if (e.key === 'ArrowLeft') {
          slider.scrollLeft -= step;
          e.preventDefault();
        }
      });
      
      // Initialize
      updateCollectionThumbPosition();
       
    });
  } else {
     
  }
});